import React, { useState } from "react";
import Datepicker from "react-tailwindcss-datepicker";

export function DatePicker({ change, defaultValue }) {
  const [dateRange, setDateRange] = useState(defaultValue);
  const handleValueChange = (newValue) => {
    const formatDate = (date) => {
      if (!date) return null;
      return date.toISOString().split("T")[0];
    };
    const formattedRange = {
      startDate: formatDate(new Date(newValue.startDate)),
      endDate: formatDate(new Date(newValue.endDate)),
    };
    change({ ...formattedRange, dateHard: newValue });
    setDateRange(formattedRange);
  };
  return (
    <div className="rounded-xl border border-slate-200 bg-white shadow-xs overflow-hidden transition-all focus-within:ring-4 focus-within:ring-primary/15 focus-within:border-primary">
      <Datepicker
        separator="a"
        i18n={"es"}
        primaryColor={"indigo"}
        showFooter={true}
        showShortcuts={true}
        configs={{
          shortcuts: {
            today: "Hoy",
            yesterday: "Ayer",
            past: (period) => "Últimos " + period + " días",
            currentMonth: "Este mes",
            pastMonth: "Mes pasado",
          },
          footer: {
            cancel: "Cancelar",
            apply: "Aceptar",
          },
        }}
        value={dateRange}
        onChange={handleValueChange}
      />
    </div>
  );
}